var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSecure(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    rx: 30,
    fill: "#509BF5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.8594 33.084C17.8594 38.2753 20.7073 40.3076 28.8796 44.7869C29.2521 44.9836 29.6258 45.0817 29.8765 45.0817C30.1273 45.0817 30.5126 44.9836 30.8735 44.7869C39.0574 40.3193 41.8937 38.2753 41.8937 33.084V22.3261C41.8937 20.6399 41.2406 20.0448 39.8286 19.4429C38.2469 18.784 32.9149 16.9088 31.3638 16.3792C30.8925 16.2281 30.3544 16.1299 29.8765 16.1299C29.3987 16.1299 28.8605 16.254 28.4009 16.3792C26.8498 16.822 21.5062 18.7957 19.9244 19.4429C18.5242 20.0331 17.8594 20.6399 17.8594 22.3261V33.084ZM20.5317 32.5524V30.2485H29.874V18.8077C30.0792 18.8077 30.2974 18.8606 30.6199 18.969C32.5253 19.7178 36.5922 21.1647 38.7338 21.9189C39.1231 22.0663 39.2213 22.2783 39.2213 22.7801V30.2485H29.8765V42.0937C29.6719 42.0937 29.4698 42.0187 29.0557 41.7676C22.5507 37.8012 20.5317 36.7342 20.5317 32.5524Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecure);
export default __webpack_public_path__ + "static/media/secure.368d61dd56d68d5b89be35ed6879daca.svg";
export { ForwardRef as ReactComponent };